import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Text,
  Td,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useColorModeValue,
  Center,
  Spinner,
  // Select,
} from "@chakra-ui/react";
import { FaHistory } from "react-icons/fa";
import { BiSliderAlt } from "react-icons/bi";
import useUser from "hooks/use-user";
// import "./multiSelect.css";
import useReceivingSector from "hooks/use-receiving";
import dayjs from "dayjs";
import useInventory from "hooks/use-inventory";

interface AddUserModalProps {}

const ModalHistoricInventory: React.FC<AddUserModalProps> = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { getDataHistoric, loadingHistoric, dataHistoric } = useInventory();
  const [selectedId, setSelectedId] = useState(null);

  const colorSpinner = useColorModeValue("black", "white");
  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  useEffect(() => {
    if (isOpen) {
      getDataHistoric();
    }
  }, [isOpen]);
  return (
    <>
      <Button colorScheme="green" variant="outline" onClick={handleOpen}>
        Abrir Histórico {"\u00A0"}
        {""}
        <FaHistory />
      </Button>
      <Modal isOpen={isOpen} onClose={handleClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={"gray.200"}
            background={"#1d5840"}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                Histórico Modificacoes Inventario
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody>
            <Box overflowX="auto" maxHeight={490}>
              {loadingHistoric ? (
                <>
                  <Box h={40}>
                    <Center pt={10}>
                      <Flex
                        direction="column"
                        alignItems="center"
                        textAlign="center"
                      >
                        <Spinner
                          thickness="4px"
                          speed="0.65s"
                          emptyColor="gray.200"
                          color={colorSpinner}
                          size="xl"
                        />
                        <Text
                          color={colorSpinner}
                          marginTop="4"
                          fontSize="xl"
                          fontWeight="bold"
                        >
                          Buscando dados
                        </Text>
                      </Flex>
                    </Center>
                  </Box>
                </>
              ) : (
                <>
                  <Table>
                    <Thead>
                      <Tr bg="gray.200">
                        <Th bg="gray.200">Data</Th>
                        <Th>Usuario</Th>
                        <Th>Loja</Th>
                        <Th>Setor</Th>
                        <Th>Acao</Th>
                      </Tr>
                    </Thead>
                    <Tbody overflowY="auto">
                      {dataHistoric.map((item: any) => (
                        <Tr>
                          <Td>
                            {" "}
                            {dayjs(item.date)
                              .subtract(-1, "day")
                              .format("DD/MM/YYYY ")}
                          </Td>
                          <Td>{item.user} </Td>
                          <Td>{item.storeId}</Td>
                          <Td>{item.sector}</Td>
                          <Td>{item.action}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </>
              )}
            </Box>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalHistoricInventory;
